import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_12: FaireProductEntity = {
  token: "catalog_prod_prod-12",
  type: "product",
  name: "Party Plates - Cake Slice Design (Set of 8)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 85.3,
  msrpDollars: 213.25,
  sku: "CO0012",
  caseSize: 6,
  material: "Wood",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 467,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_book-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
